<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>港口名称：</p>
        <el-input v-model="condition.portName" size="mini" style="width: 150px" placeholder="请输入港口名称" />
      </div>
      <!-- <div class="navContainer" style="width: 230px">
        <p>有效起始：</p>
        <el-date-picker
          v-model="condition.startTime"
          style="width:150px"
          type="date"
          size="mini"
          placeholder="选择有效起始">
        </el-date-picker>
      </div> -->
      <div class="navContainer" style="width: 230px">
        <p>状态：</p>
        <el-select v-model="condition.status" size="mini" filterable style="width: 150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px" v-if="false">
        <p>类型：</p>
        <el-select v-model="condition.contractType" size="mini" filterable style="width: 150px" placeholder="请选择类型">
          <el-option v-for="item in contractTypeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>结算方式：</p>
        <el-select v-model="condition.contractType" size="mini" filterable style="width: 150px" placeholder="请选择类型">
          <el-option v-for="item in contractTypeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="condition.createByName" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          row-key="id"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="portName" label="港口名称" width="150px" align="center" />
          <el-table-column prop="freeNum" label="免堆数量" align="center" />
          <el-table-column label="免堆类型" align="center">
            <div slot-scope="scope">{{ getType(scope.row.freeType) }}</div>
          </el-table-column>
          <el-table-column prop="chargePrice" label="计费单价" align="center" />
          <el-table-column label="固定价格" align="center">
            <template slot-scope="scope">
              {{ scope.row.fixedPrice ? scope.row.fixedPrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="150" align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column prop="createByName" label="录入人员" show-overflow-tooltip width="150" align="center" />
          <el-table-column prop="startDate" label="有效起始" width="150px" align="center" />
          <el-table-column prop="endDate" label="结束时间" width="150px" align="center" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" min-width="360" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情 </el-button>
                <el-button size="mini" class="yellow-bg" v-if="scope.row.status === 0 || scope.row.status === 1" :loading="scope.row.changeLoad" type="primary" @click="changeClick(scope.row, scope.row.status)">
                  {{ !scope.row.status ? '修改' : '修改车型' }}
                </el-button>
                <el-button size="mini" v-if="scope.row.status == 0" type="primary" @click="enableClick(scope.row.id)">启用 </el-button>
                <el-button size="mini" v-if="scope.row.status == 1" type="danger" @click="disableClick(scope.row.id)">停用 </el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="600px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">港口名称：</span>
              <span>{{ detailData.portName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">适配车型：</span>
              <span>{{ detailData.customerCarName }}</span>
              <!-- <span>{{detailData.models}}</span> -->
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">有效起始：</span>
              <span>{{ detailData.startDate }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">结束时间：</span>
              <span>{{ detailData.endDate }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">税率：</span>
              <span>{{ detailData.taxRate }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1" v-if="detailData.contractType === 1 && detailData.flowType === 1">上水免堆数量：</span>
                <span class="span1" v-else>免堆数量：</span>
                <span>{{ detailData.freeNum }}</span>
                <span v-if="detailData.freeType == 1"> 时</span>
                <span v-else> 天</span>
              </div>
              <div class="specialOne" v-if="detailData.contractType === 1 && detailData.flowType === 1">
                <span class="span1" v-if="detailData.contractType === 1 && detailData.flowType === 1">下水免堆数量：</span>
                <span class="span1" v-else>免堆数量：</span>
                <span>{{ detailData.freeNumLower }}</span>
                <span v-if="detailData.freeType == 1"> 时</span>
                <span v-else> 天</span>
              </div>
              <!--              <div class='specialOne'>
                              <span class='span1'>计费数量：</span>
                              <span>{{ detailData.chargeNum }}</span>
                              <span v-if='detailData.chargeType==1'> 时</span>
                              <span v-else> 天</span>
                            </div>-->
            </div>
            <!--            <div class='baseInfoContentItem'>
                          <span class='span1'>计费单价：</span>
                          <span>{{ detailData.chargePrice || 0 }} 元</span>
                        </div>-->
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>价格设置</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem" v-if="detailData.contractType === -1">
              <span class="span1">计费数量：</span>
              <span>{{ detailData.chargeNum }}</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType === -1">
              <span class="span1">计费单价：</span>
              <span>{{ detailData.chargePrice || 0 }}元</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType === 0">
              <span class="span1">固定价：</span>
              <span>{{ detailData.fixedPrice || 0 }}元</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType === 1 && detailData.flowType === 0">
              <span class="span1">阶梯合同价：</span>
              <div>
                <el-table :data="detailData.ladderList" border>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="startNum" label="起始天数" align="center" />
                  <el-table-column prop="endNum" label="结束天数" align="center" />
                  <el-table-column prop="contractPrice" label="合同价" align="center" />
                </el-table>
              </div>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType === 1 && detailData.flowType === 1">
              <span class="span1">阶梯合同价-上水：</span>
              <div>
                <el-table :data="detailData.ladderListUpper" border>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="startNum" label="起始天数" align="center" />
                  <el-table-column prop="endNum" label="结束天数" align="center" />
                  <el-table-column prop="contractPrice" label="合同价" align="center" />
                </el-table>
              </div>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.contractType === 1 && detailData.flowType === 1">
              <span class="span1">阶梯合同价-下水：</span>
              <div class="tableStyle">
                <el-table :data="detailData.ladderListLower" border>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="startNum" label="起始天数" align="center" />
                  <el-table-column prop="endNum" label="结束天数" align="center" />
                  <el-table-column prop="contractPrice" label="合同价" align="center" />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="detailData.operateRecordList"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '12px',
                height: '40px',
                background: '#E8E8E8',
              }">
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增/修改弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px" center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="140px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <el-row>
              <el-col v-if="editType === 0">
                <el-form-item label="港口名称：" style="margin-top: 10px" prop="portName">
                  <el-select v-model="companyData.portName" size="mini" style="width: 100%" filterable placeholder="请选择港口名称"
                             value-key="id" @change="nameChange">
                    <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :class="{ mt10: editType === 1 }">
                <el-form-item label="适配车型：" prop="model">
                  <cascader
                    ref="cascader"
                    :options="modelOption"
                    :props="{
                      value: 'id',
                      label: 'model',
                      children: 'carModel',
                      multiple: true,
                    }"
                    :filed="'model'"
                    @getValue="getValue" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker v-model="companyData.start" size="mini" type="datetime" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择有效期始" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="结束时间：" prop="end">
                  <el-date-picker v-model="companyData.end" size="mini" type="datetime" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" placeholder="请选择有效结束时间" />
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="合同设置" divStyle="margin-top: 10px">
            <el-row>
              <el-col :span='24'>
                <el-form-item label='合同：' prop='contract' style="margin-top: 15px">
                  <el-select v-model="companyData.contract" filterable style="width: 100%" size="small"
                             placeholder="请选择合同" value-key="id" @change="getPortName">
                    <el-option
                      v-for="item in contractOption" :key="item.id" :label="item.name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="价格设置" divStyle="margin-top: 10px" v-if="editType === 0">
            <el-row>
              <el-col>
                <el-form-item label="税率：" style="margin-top: 10px" prop="tax">
                  <el-input style="width: 100%" v-model="companyData.tax" placeholder="请输入税率" autocomplete="off" size="mini"> <span slot="suffix" class="input-span">%</span></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="结算方式：" prop="contractType" @click.native="stateUpdate">
                  <el-radio size="mini" v-model="companyData.contractType" :label="-1">无</el-radio>
                  <el-radio size="mini" v-model="companyData.contractType" :label="0">固定</el-radio>
                  <el-radio size="mini" v-model="companyData.contractType" :label="1">阶梯</el-radio>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="companyData.flowType === 1 ? '上水-免堆数量：' : '免堆数量：'" style="margin-top: 10px; width: calc(100% - 100px); display: inline-block" prop="heapFree">
                  <el-input style="width: 100%" v-model="companyData.heapFree" placeholder="请输入免堆数量" autocomplete="off" size="mini" />
                </el-form-item>
                <el-select v-model="companyData.heapUnit" filterable size="mini" style="width: 90px; margin-left: 10px">
                  <el-option label="时" value="1" />
                  <el-option label="天" value="2" />
                </el-select>
              </el-col>
              <el-col v-if="companyData.flowType === 1">
                <el-form-item label="下水-免堆数量：" style="margin-top: 10px; width: calc(100% - 100px); display: inline-block" prop="heapFree">
                  <el-input style="width: 100%" v-model="companyData.freeNumLower" placeholder="请输入免堆数量" autocomplete="off" size="mini" />
                </el-form-item>
                <el-select v-model="companyData.freeTypeLower" filterable size="mini" style="width: 90px; margin-left: 10px">
                  <el-option label="时" value="1" />
                  <el-option label="天" value="2" />
                </el-select>
              </el-col>
              <el-col v-if="companyData.contractType === 0">
                <el-form-item label="固定合同价：" prop="fixedPrice" style="margin-bottom: 17px">
                  <el-input style="width: 150px" v-model="companyData.fixedPrice" placeholder="请输入固定合同价" autocomplete="off" size="small">
                    <span slot="suffix" style="color: #999">| 元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.contractType === -1">
                <el-form-item label="计费数量：" style="margin-top: 10px; width: calc(100% - 100px); display: inline-block" prop="billing">
                  <el-input style="width: 100%" v-model="companyData.billing" placeholder="请输入计费数量" autocomplete="off" size="mini" />
                </el-form-item>
                <el-select v-model="companyData.billingUnit" filterable size="mini" style="width: 90px; margin-left: 10px">
                  <el-option label="时" value="1" />
                  <el-option label="天" value="2" />
                </el-select>
              </el-col>
              <el-col v-if="companyData.contractType === -1">
                <el-form-item label="计费单价：" style="margin-top: 10px; padding-bottom: 10px" prop="price">
                  <el-input style="width: 100%" v-model="companyData.price" placeholder="请输入计费单价" autocomplete="off" size="mini"> <span slot="suffix" class="input-span">元</span></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.contractType === 1">
                <el-form-item label="阶梯方式：" prop="flowType">
                  <el-radio size="mini" v-model="companyData.flowType" :label="0">全水</el-radio>
                  <el-radio size="mini" v-model="companyData.flowType" :label="1">上水、下水</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.flowType === 0 && companyData.contractType === 1">
                <el-form-item label="阶梯合同价：" prop="ladderList">
                  <el-table border :data="companyData.ladderList">
                    <el-table-column label="序号" align="center" type="index" />
                    <el-table-column label="起始天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderList[scope.$index].startNum" :disabled="scope.$index !== 0" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="结束天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderList[scope.$index].endNum" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="价格" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderList[scope.$index].contractPrice" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
                        <img v-if="scope.$index === 0 && Number(companyData.ladderList[scope.$index].startNum) > Number(companyData.ladderList[scope.$index].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderList', true)" />
                        <img v-else-if="scope.$index !== 0 && Number(companyData.ladderList[scope.$index].startNum) <= Number(companyData.ladderList[scope.$index - 1].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderList')" />
                        <img v-else-if="scope.$index + 1 === companyData.ladderList.length" alt="" :src="require('@/assets/images/add.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="addImgClick('ladderList')" />
                        <span v-else>-</span>
                      </div>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.flowType === 1 && companyData.contractType === 1">
                <el-form-item label="阶梯合同价-上水：" prop="ladderListUpper">
                  <el-table border :data="companyData.ladderListUpper">
                    <el-table-column label="序号" align="center" type="index" />
                    <el-table-column label="起始天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListUpper[scope.$index].startNum" :disabled="scope.$index !== 0" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="结束天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListUpper[scope.$index].endNum" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="价格" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListUpper[scope.$index].contractPrice" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
                        <img v-if="scope.$index === 0 && Number(companyData.ladderListUpper[scope.$index].startNum) > Number(companyData.ladderListUpper[scope.$index].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderListUpper', true)" />
                        <img v-else-if="scope.$index !== 0 && Number(companyData.ladderListUpper[scope.$index].startNum) < Number(companyData.ladderListUpper[scope.$index - 1].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderListUpper')" />
                        <img v-else-if="scope.$index + 1 === companyData.ladderListUpper.length" alt="" :src="require('@/assets/images/add.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="addImgClick('ladderListUpper')" />
                        <span v-else>-</span>
                      </div>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
              <el-col v-if="companyData.flowType === 1 && companyData.contractType === 1">
                <el-form-item label="阶梯合同价-下水：" prop="ladderListLower">
                  <el-table border :data="companyData.ladderListLower">
                    <el-table-column label="序号" align="center" type="index" />
                    <el-table-column label="起始天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListLower[scope.$index].startNum" :disabled="scope.$index !== 0" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="结束天数" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListLower[scope.$index].endNum" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="价格" align="center">
                      <template slot-scope="scope">
                        <el-input type="number" v-model="companyData.ladderListLower[scope.$index].contractPrice" size="mini" style="width: 100%" placeholder="请输入" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
                        <img v-if="scope.$index === 0 && Number(companyData.ladderListLower[scope.$index].startNum) > Number(companyData.ladderListLower[scope.$index].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderListLower', true)" />
                        <img v-else-if="scope.$index !== 0 && Number(companyData.ladderListLower[scope.$index].startNum) < Number(companyData.ladderListLower[scope.$index - 1].endNum)" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, 'ladderListLower')" />
                        <img v-else-if="scope.$index + 1 === companyData.ladderListLower.length" alt="" :src="require('@/assets/images/add.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="addImgClick('ladderListLower')" />
                        <span v-else>-</span>
                      </div>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定 </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import {
    addStockpiled,
    reviseStockpiled,
    stockpiledList,
    detailsList,
    enableStockpiled,
    disableStockpiled,
    deleteStockpiled,
    getCarSerieList,
    getContractInfo,
    deleteContractInfo,
    contractPageList
  } from '@/service/financial';
  import { supplierPublicSelectPort } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
      cascader,
    },
    data() {
      return {
        condition: {
          portName: '', // 港口名称
          // startTime: '', // 有效起始
          status: '', // 状态
          contractType: '', // 类型
          createByName: '',
        },
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        contractTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '固定',
          },
          {
            value: 1,
            label: '阶梯',
          },
          {
            value: -1,
            label: '无',
          },
        ],
        page: 1, // 当前页
        size: 10, // 每页数据条数
        total: 0, // 总数居条数
        tableLoad: false, // 表格加载状态
        TableDatas: [], // 表格数据
        detailDialogVisible: false, // 详情弹窗是否显示控制变量
        detailData: {}, // 详情弹窗数据
        operationData: [], // 详情操作信息表格数据
        dialogVisible: false, // 新增/修改弹窗是否显示控制变量
        dialogTitle: '', // 新增/修改弹窗标题
        changeLoad: false,
        addLoad: false,
        portOption: [], // 新增/修改弹窗港口名称数据
        modelOption: [], // 新增/修改弹窗适配车型数据
        modelMap: new Map(), // 型号的map
        brandMap: new Map(), // 品牌的map
        contractOption: [],// 新增/修改弹窗合同数据
        companyData: {
          portName: '', // 港口名称
          model: '', // 适配车型
          start: '', // 有效期始
          end: '', // 结束时间
          tax: '', // 税率
          contract: '',//合同
          heapFree: '', // 免堆数量
          heapUnit: '1', // 免堆数量单位
          freeNumLower: '', // 免堆数量
          freeTypeLower: '1', // 免堆数量单位
          billing: '', // 计费数量
          billingUnit: '1', // 计费数量单位
          price: '', // 计费单价
          contractType: -1, // 结算方式
          fixedPrice: '', // 固定合同价
          flowType: '', // 阶梯方式
          ladderList: [], // 全水
          ladderListUpper: [], // 上水
          ladderListLower: [], // 上水
        }, // 新增/修改数据
        rules: {
          // 表单验证
          portName: [
            {
              required: true,
              message: '请选择港口名称',
              trigger: 'change',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'change',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择作业类型',
              trigger: 'change',
            },
          ],
          start: [
            {
              required: true,
              message: '请选择有效期始',
              trigger: 'change',
            },
          ],
          end: [
            {
              required: true,
              message: '请选择结束时间',
              trigger: 'change',
            },
          ],
          tax: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'change',
            },
          ],
          heapFree: [
            {
              required: true,
              message: '请输入免堆数量',
              trigger: 'change',
            },
          ],
          billing: [
            {
              required: true,
              message: '请输入计费数量',
              trigger: 'change',
            },
          ],
          price: [
            {
              required: true,
              message: '请输入计费单价',
              trigger: 'change',
            },
          ],
          fixedPrice: [
            {
              required: true,
              message: '请输入固定合同价',
              trigger: 'change',
            },
          ],
          flowType: [
            {
              required: true,
              message: '请选择阶梯方式',
              trigger: 'change',
            },
          ],
          ladderList: [
            {
              required: true,
              message: '请输入阶梯合同价',
              trigger: 'change',
            },
          ],
          ladderListUpper: [
            {
              required: true,
              message: '请输入阶梯合同价-上水',
              trigger: 'change',
            },
          ],
          ladderListLower: [
            {
              required: true,
              message: '请输入阶梯合同价-下水',
              trigger: 'change',
            },
          ],
        },
        editType: 0,
        checkTableData: [],
      };
    },
    computed: {
      // 获取免堆类型
      getType() {
        return function (state) {
          switch (state) {
            case 1:
              return '时';
            case 2:
              return '天';
          }
        };
      },
      // 获取状态
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      // 时间格式
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    async mounted() {
      await this._stockpiledList();
    },
    methods: {
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0) return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认启用当前选中港口堆存费单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            const res = await enableStockpiled(params.join(','));
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._stockpiledList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      stateUpdate() {
        this.companyData.flowType = '';
      },
      addImgClick(field) {
        if (!this.companyData[field][this.companyData[field].length - 1].endNum) return this.$message.warning('请先输入结束天数！');
        if (isNaN(Number(this.companyData[field][this.companyData[field].length - 1].endNum))) return (this.companyData[field][this.companyData[field].length - 1].endNum = '');
        if (Number(this.companyData[field][this.companyData[field].length - 1].endNum) < Number(this.companyData[field][this.companyData[field].length - 1].startNum)) {
          this.companyData[field][this.companyData[field].length - 1].endNum = '';
          return this.$message.warning('结束天数必须大于开始天数！');
        }
        this.companyData[field].push({
          startNum: Number(this.companyData[field][this.companyData[field].length - 1].endNum) + 1,
        });
      },
      /**
       * 删除数据
       * @param index 索引
       * @param field 字段
       * @param flag 是否首条数据
       */
      removeClick(index, field, flag) {
        if (flag) {
          this.companyData[field] = [{ startNum: 0 }];
        } else {
          this.companyData[field].splice(index, 2);
        }
      },
      // 获取表格数据(分页查询)
      async _stockpiledList() {
        this.tableLoad = true;
        const res = await stockpiledList({
          portName: this.condition.portName,
          // startTime:this.condition.startTime,
          status: this.condition.status,
          contractType: this.condition.contractType,
          createByName: this.condition.createByName,
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 获取港口
      async getPort() {
        const res = await supplierPublicSelectPort();
        this.portOption = res.data;
      },
      // 获取适配车型 modelOption
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach(item => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
        // console.log(this.modelOption);
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._stockpiledList();
      },
      // 重置
      resetBtn() {
        this.condition = {
          portName: '',
          status: '',
          contractType: '',
        };
      },
      // 更改每页条数
      contractSizeChange(sizes) {
        this.size = sizes;
        this._stockpiledList();
      },
      // 翻页/更改当前页数
      contractCurrentChange(page) {
        this.page = page;
        this._stockpiledList();
      },
      // 判断时间大小
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        return date.getTime() - date1.getTime() < 0;
      },
      // 港口名称改变
      nameChange(val) {
        this.companyData.contract = ''
        this._contractPageList(val);
      },
      getPortName(){
        if(this.companyData.portName === '') return  this.$message.warning('请先选择港口！');
        this._contractPageList()
      },
      // 合同设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          id: this.companyData.portName.supplier_id,
        };
        let res = await contractPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      // 新增/修改
      addClick() {
        this.addLoad = true;
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (!this.bjDate(this.companyData.start, this.companyData.end)) return this.$message.warning('结束时间不得小于开始时间！');
            if (this.companyData.contractType === 1 && this.companyData.flowType === 0) {
              for (let i = 0; i < this.companyData.ladderList.length; i++) {
                if (!this.companyData.ladderList[i].contractPrice || this.companyData.ladderList[i].contractPrice === '') {
                  return this.$message.warning('请填入阶梯合同价的价格');
                }
              }
              if (this.companyData.ladderList[this.companyData.ladderList.length - 1].endNum) {
                if (Number(this.companyData.ladderList[this.companyData.ladderList.length - 1].startNum) > Number(this.companyData.ladderList[this.companyData.ladderList.length - 1].endNum)) return this.$message.warning('最后一行起始天数不能高于结束天数！');
              } else {
                return this.$message.warning('请输入最后一行的结束天数');
              }
            } else if (this.companyData.contractType === 1 && this.companyData.flowType === 1) {
              for (let i = 0; i < this.companyData.ladderListUpper.length; i++) {
                if (!this.companyData.ladderListUpper[i].contractPrice || this.companyData.ladderListUpper[i].contractPrice === '') {
                  return this.$message.warning('请填入阶梯合同价-上水的价格');
                }
              }
              if (this.companyData.ladderListUpper[this.companyData.ladderListUpper.length - 1].endNum) {
                if (Number(this.companyData.ladderListUpper[this.companyData.ladderListUpper.length - 1].startNum) > Number(this.companyData.ladderListUpper[this.companyData.ladderListUpper.length - 1].endNum)) return this.$message.warning('最后一行起始天数不能高于结束天数！');
              } else {
                return this.$message.warning('请输入最后一行的结束天数');
              }
              for (let i = 0; i < this.companyData.ladderListLower.length; i++) {
                if (!this.companyData.ladderListLower[i].contractPrice || this.companyData.ladderListLower[i].contractPrice === '') {
                  return this.$message.warning('请填入阶梯合同价-下水的价格');
                }
              }
              if (this.companyData.ladderListLower[this.companyData.ladderListLower.length - 1].endNum) {
                if (Number(this.companyData.ladderListLower[this.companyData.ladderListLower.length - 1].startNum) > Number(this.companyData.ladderListLower[this.companyData.ladderListLower.length - 1].endNum)) return this.$message.warning('最后一行起始天数不能高于结束天数！');
              } else {
                return this.$message.warning('请输入最后一行的结束天数');
              }
            }
            let obj = {
              id: this.companyData.id || '',
              portName: this.companyData.portName.supplier_name, // 港口名称
              portId: this.companyData.portName.id, // 港口id
              carModelList: this.companyData.model.map(item => {
                return {
                  brandId: item[0], // 品牌id
                  brandName: this.brandMap.get(item[0]), // 品牌名称
                  modelId: item[1], // 委托车型号id
                  modelName: this.modelMap.get(item[1]), // 委托车型号名称
                };
              }), // 适配车型
              startDate: this.companyData.start, // 有效期始
              endDate: this.companyData.end, // 结束时间
              taxRate: this.companyData.tax, // 税率
              freeNum: this.companyData.heapFree, // 免堆数量
              freeType: this.companyData.heapUnit, // 免堆数量单位
              chargeNum: this.companyData.billing, // 计费数量
              chargeType: this.companyData.contractType === -1 ? this.companyData.billingUnit : '', // 计费数量单位
              chargePrice: this.companyData.contractType === -1 ? this.companyData.price : '', // 计费单价
              status: this.companyData.status,
              contractId: this.companyData.contract.id,
              contractName: this.companyData.contract.contractName,
              contractType: this.companyData.contractType,
              freeNumLower: this.companyData.freeNumLower,
              freeTypeLower: this.companyData.freeTypeLower,
              fixedPrice: this.companyData.contractType === 0 ? this.companyData.fixedPrice : '',
              flowType: this.companyData.contractType === 1 ? this.companyData.flowType : '',
              ladderList: this.companyData.contractType === 1 && this.companyData.flowType === 0 ? this.companyData.ladderList : [],
              ladderListUpper: this.companyData.contractType === 1 && this.companyData.flowType ? this.companyData.ladderListUpper : [],
              ladderListLower: this.companyData.contractType === 1 && this.companyData.flowType ? this.companyData.ladderListLower : [],
            };
            const res = this.dialogTitle != '修改港口价格' ? await addStockpiled(obj) : await reviseStockpiled(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            if (this.$refs.ruleForm !== undefined) {
              this.$refs.ruleForm.resetFields();
            }
            await this._stockpiledList();
          } else {
            return false;
          }
        });
      },
      // 启用
      enableClick(id) {
        this.$confirm('确认启用当前港口堆存费单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            // 调用启用弹窗
            const res = await enableStockpiled(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._stockpiledList();
          })
          .catch(() => {});
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认删除当前港口堆存费单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            // 调用删除接口
            const res = await deleteStockpiled(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._stockpiledList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认删除当前选中的港口堆存费单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              // 调用删除接口
              const res = await deleteStockpiled(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._stockpiledList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      // 停用
      disableClick(id) {
        this.$confirm('确认停用当前港口堆存费单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            // 调用停用接口
            const res = await enableStockpiled(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._stockpiledList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认停用当前港口堆存费单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              // 调用停用接口
              const res = await enableStockpiled(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this.$message.success(res.message);

              await this._stockpiledList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的港口堆存费单价设置！',
            type: 'warning',
          });
        }
      },
      // 打开详情弹窗
      async detailClick(row) {
        let res = await detailsList(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.detailData.models = '';
        if (res.data.carModelList.length > 0) {
          res.data.carModelList.forEach(item => {
            console.log(item);
            this.detailData.models += item.brandName + ',';
          });
          this.detailData.models = this.detailData.models.substr(0, this.detailData.models.length - 1);
        }
        this.detailDialogVisible = true;
      },
      // 打开新增弹窗
      addBtn() {
        this.editType = 0;
        this.getPort();
        this._getCarSerieList();
        this.dialogVisible = true;
        if (this.$refs.ruleForm !== undefined) {
          this.$refs.ruleForm.resetFields();
        }
        this.dialogTitle = '添加港口堆存费价格';
        this.companyData = {
          portName: '',
          model: '',
          start: '',
          end: '',
          tax: '',
          contract: '',
          heapFree: '',
          heapUnit: '1',
          freeNumLower: '',
          freeTypeLower: '1',
          billing: '',
          billingUnit: '1',
          price: '',
          contractType: -1,
          fixedPrice: '',
          flowType: '',
          ladderList: [{ startNum: 0 }],
          ladderListUpper: [{ startNum: 0 }],
          ladderListLower: [{ startNum: 0 }],
        };
      },
      // 打开修改弹窗
      async changeClick(row, type) {
        this.editType = type;
        row.changeLoad = true;
        await this.getPort();
        await this._getCarSerieList();
        let res = await detailsList(row.id);
        row.changeLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        let model = [];
        if (res.data.carModelList.length > 0) {
          res.data.carModelList.forEach(item => {
            model.push([item.brandId, item.modelId]);
          });
        }
        let name = '';
        if (res.data.contractCode != null && res.data.contractCode !== '') {
          name = res.data.contractCode + '-' + res.data.contractName;
        } else {
          name = null;
        }
        this.companyData = {
          id: res.data.id,
          status: res.data.status,
          portName: {
            supplier_name: res.data.portName,
            id: res.data.portId,
          }, // 港口名称
          contract:{
            id: res.data.contractId,
            name:name
          }, // 合同
          model: model, // 适配车型
          start: res.data.startDate, // 有效期始
          end: res.data.endDate, // 结束时间
          tax: res.data.taxRate, // 税率
          heapFree: res.data.freeNum, // 免堆数量
          heapUnit: res.data.freeType + '', // 免堆数量单位
          freeNumLower: res.data.freeNumLower, // 下水-免堆数量
          freeTypeLower: res.data.freeTypeLower + '', // 下水-免堆数量单位
          billing: res.data.chargeNum, // 计费数量
          billingUnit: res.data.chargeType ? res.data.chargeType + '' : '1', // 计费数量单位
          price: res.data.chargePrice,
          contractType: res.data.contractType,
          fixedPrice: res.data.fixedPrice,
          flowType: res.data.flowType,
          ladderList: res.data.ladderList ? res.data.ladderList : [{ startNum: 0 }],
          ladderListUpper: res.data.ladderListUpper ? res.data.ladderListUpper : [{ startNum: 0 }],
          ladderListLower: res.data.ladderListLower ? res.data.ladderListLower : [{ startNum: 0 }],
        };
        let data = await contractPageList(this.companyData.portName.supplier_id);
        if (data.status !== 0) return this.$message.error(data.message);
        this.contractOption = data.data;
        this.dialogTitle = '修改港口价格';
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.cascader.value = model;
        });
        if (this.$refs.ruleForm !== undefined) {
          this.$refs.ruleForm.resetFields();
        }
      },
      // 关闭新增/修改弹窗
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.cascader.value = [];
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.companyData[filed] = subData;
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/port/stockpile/export?access_token=${token}&portName=${this.condition.portName}&state=${this.condition.state}&contractType=${this.condition.contractType}`;
        window.exportExcelGet('/platform/price/port/stockpile/export', `portName=${this.condition.portName}&state=${this.condition.state}&contractType=${this.condition.contractType}`)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            .span1 + div {
              ::v-deep {
                .cell {
                  font-size: 10px;
                  padding: 0;
                }
              }
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 20px 10px 20px;
      max-height: 70vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .input-span {
      display: inline-block;
      color: rgb(153, 153, 153);
      border-left: 1px solid #dcdfe6;
      padding: 0px 5px 0 10px;
      height: 28px;
      line-height: 28px;
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
